// src/app/[locale]/(public)/(marketing)/faq/FaqAccordion.tsx
"use client";

import React, { useState } from "react";
import FAQAccordion, { FAQItem } from "@/components/faq/FAQAccordion";

interface FaqAccordionProps {
  items: FAQItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [expandedIndex, setExpandedIndex] = useState<number>(-1);

  const handleToggle = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <FAQAccordion
      items={items}
      expandedIndex={expandedIndex}
      onToggle={handleToggle}
    />
  );
}
